var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.avatar,
    ( _obj = {}, _obj[_vm.$style.defaultAvatar] = !_vm.has_avatar, _obj )
  ],style:(_vm.avatar_img)},[(!_vm.has_avatar)?_c('span',[_vm._v(" "+_vm._s(_vm.default_avatar)+" ")]):_vm._e(),(_vm.is_edit)?[_c('input',{class:_vm.$style.fileInput,attrs:{"accept":".jpg, .jpeg, .png","type":"file","id":"avatar-input"},on:{"change":_vm.uploaded_new_img}}),_c('label',{class:_vm.$style.avatarLabel,attrs:{"for":"avatar-input"}},[_c('v-icon',{class:_vm.$style.plusIcon},[_vm._v("mdi-plus")])],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }